export const ACTIVE_ENVIRONMENT_VARIABLE = 'DEV';
